// extracted by mini-css-extract-plugin
export var container = "_d7-0";
export var popoverContent = "_d7-1";
export var tosLink = "_d7-2";